import { db, auth, realtimeDb } from '@/plugins/firebase';
import moment from 'moment';

export async function createRecentLive(liveDoc) {
  let success = true;
  const recentLiveDocRef = await db
    .collection('recentLives')
    .add(liveDoc)
    .catch(err => {
      console.error(err);
      success = false;
    });

  if (!success) return false;

  const recentLiveDocSnapshot = await recentLiveDocRef.get();

  if (recentLiveDocSnapshot) {
    const recentLiveDoc = recentLiveDocSnapshot.data();
    recentLiveDoc['id'] = recentLiveDocSnapshot.id;
    return recentLiveDoc;
  }

  return;
}

export async function updateRecentLiveByLiveId(liveId, liveDoc) {
  let success = true;
  const recentLiveDocRef = await db.collection('recentLives').doc(liveId);

  recentLiveDocRef.set(liveDoc, { merge: true }).catch(err => {
    console.error(err);
    success = false;
  });

  if (success) {
    const recentLiveDocSnapShot = await recentLiveDocRef.get();
    return recentLiveDocSnapShot.data();
  }

  return;
}

export async function getAllRecentLives() {
  let lives = [];

  const recentLiveQuerySnapshot = await db
    .collection('recentLives')
    .limit(20)
    .get();

  if (recentLiveQuerySnapshot.empty) {
    return lives;
  } else {
    recentLiveQuerySnapshot.forEach(doc => {
      const data = doc.data();
      lives.push({
        id: doc.id,
        title: data.title,
        aboutLive: data.aboutLive,
        thumbnailUrl: data.thumbnailUrl,
        startAt: moment.unix(data.startAt.seconds).format('YYYY/MM/DD HH:mm:ss')
      });
    });
  }

  return lives;
}

export async function getRecentLiveByLiveId(liveId) {
  const liveDoc = await db.collection('recentLives').doc(liveId).get();

  if (liveDoc) {
    return liveDoc.data();
  } else {
    return false;
  }
}

export async function deleteRecentLiveByLiveId(liveId) {
  let success = true;

  await db
    .collection('recentLives')
    .doc(liveId)
    .delete()
    .catch(err => {
      console.error(err);
      success = false;
    });

  return success;
}

export async function createUpComingLive(liveDoc) {
  liveDoc['userId'] = auth.currentUser.uid;
  liveDoc['createdAt'] = new Date();

  // refference collection of scheduledLives
  const addDocResult = await db.collection('upComingLives').add(liveDoc);

  if (addDocResult) {
    return true;
  } else {
    return false;
  }
}

export async function getAllUpComingLives() {
  let lives = [];

  const upComingLiveQuerySnapshot = await db.collection('upComingLives').get();
  if (upComingLiveQuerySnapshot.empty) {
    return lives;
  } else {
    upComingLiveQuerySnapshot.forEach(doc => {
      const data = doc.data();
      lives.push({
        id: doc.id,
        title: data.title,
        aboutLive: data.aboutLive,
        thumbnailUrl: data.thumbnailUrl,
        startAt: data.startAt,
        userId: data.userId
      });
    });
  }

  return lives;
}

export async function getUpcomingLivesByUserId(userId, limit) {
  let lives = [];

  // TODO: add logic to do pagination
  const upComingLiveQuerySnapshot = await db
    .collection('upComingLives')
    .where('userId', '==', userId)
    .orderBy('startAt', 'asc')
    .limit(limit)
    .get();

  if (upComingLiveQuerySnapshot.empty) {
    return lives;
  } else {
    upComingLiveQuerySnapshot.forEach(doc => {
      const data = doc.data();
      lives.push({
        id: doc.id,
        title: data.title,
        aboutLive: data.aboutLive,
        thumbnailUrl: data.thumbnailUrl,
        startAt: data.startAt
      });
    });
  }
  return lives;
}

export async function getUpComingLiveByLiveId(liveId) {
  const liveDoc = await db.collection('upComingLives').doc(liveId).get();

  if (liveDoc) {
    return liveDoc.data();
  } else {
    return false;
  }
}

export async function deleteUpComingLiveByLiveId(liveId) {
  let success = true;

  await db
    .collection('upComingLives')
    .doc(liveId)
    .delete()
    .catch(err => {
      console.error(err);
      success = false;
    });

  return success;
}

export async function getEndedLivesByUserId(userId) {
  let lives = [];

  const endedLivesQuerySnapshot = await db
    .collection('endedLives')
    .where('userId', '==', userId)
    .get();

  if (endedLivesQuerySnapshot.empty) {
    return lives;
  } else {
    endedLivesQuerySnapshot.forEach(doc => {
      const data = doc.data();
      lives.push({
        id: doc.id,
        title: data.title,
        aboutLive: data.aboutLive,
        thumbnailUrl: data.thumbnailUrl,
        startAt: data.startAt
      });
    });
  }

  return lives;
}

export async function updateEndedLiveByLiveId(liveId, liveDoc) {
  let success = true;
  const endedLiveDocRef = await db.collection('endedLives').doc(liveId);
  endedLiveDocRef.set(liveDoc).catch(err => {
    success = false;
    console.error(err);
  });

  if (success) {
    const endedLiveDocSnapShot = await endedLiveDocRef.get();
    return endedLiveDocSnapShot.data();
  }

  return;
}

export async function getLiveCommentRefObj(liveId) {
  return await realtimeDb.ref(`liveComments/${liveId}`);
}

export async function getGifts() {
  let gifts = [];

  const giftsQuerySnapshot = await db.collection('gifts').get();

  if (giftsQuerySnapshot.empty) {
    return gifts;
  } else {
    giftsQuerySnapshot.forEach(doc => {
      const data = doc.data();
      gifts.push({
        id: doc.id,
        name: data.name,
        nameJP: data.nameJP,
        price: data.price,
        iconURL: data.iconURL
      });
    });
  }

  return gifts;
}
